import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { EnvelopeSimple, LinkedinLogo, GithubLogo, FileText } from "@phosphor-icons/react";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
};

const links = [
  {
    icon: EnvelopeSimple,
    label: "Email",
    href: "mailto:goyalhimanshu079@gmail.com",
    display: "goyalhimanshu079@gmail.com",
  },
  {
    icon: LinkedinLogo,
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/himanshu-goyal-581881214/",
    display: "linkedin.com/in/himanshu-goyal",
  },
  {
    icon: GithubLogo,
    label: "GitHub",
    href: "https://github.com/goyal079",
    display: "github.com/goyal079",
  },
  {
    icon: FileText,
    label: "Resume",
    href: "https://drive.google.com/file/d/1smdR0_KYP7OnT3UZl3fnY9vD-pJShwcJ/view?usp=drive_link",
    display: "View Resume",
  },
];

export const Contact = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="contact" ref={ref} data-testid="contact-section" className="py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial="initial"
          animate={isInView ? "animate" : "initial"}
          transition={{ staggerChildren: 0.1 }}
          className="max-w-2xl"
        >
          <motion.span
            variants={fadeUp}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="inline-block text-xs font-mono text-[#38bdf8] tracking-wider uppercase mb-4"
          >
            Contact
          </motion.span>
          <motion.h2
            variants={fadeUp}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            data-testid="contact-heading"
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#EDEDED] tracking-tight mb-4"
          >
            Let's connect.
          </motion.h2>
          <motion.p
            variants={fadeUp}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="text-base text-[#A1A1AA] leading-relaxed mb-12"
          >
            Interested in product systems, AI workflows, and scalable engineering problems.
          </motion.p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
          {links.map((link, i) => (
            <motion.a
              key={i}
              href={link.href}
              target={link.href.startsWith("mailto") ? undefined : "_blank"}
              rel={link.href.startsWith("mailto") ? undefined : "noopener noreferrer"}
              initial={{ opacity: 0, y: 16 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.3 + i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="flex items-center gap-4 bg-[#121212] border border-white/[0.08] rounded-xl p-5 hover:border-white/[0.15] hover:bg-white/[0.02] transition-all duration-300 group"
              data-testid={`contact-link-${link.label.toLowerCase()}`}
            >
              <div className="w-10 h-10 rounded-lg bg-white/[0.05] border border-white/[0.08] flex items-center justify-center group-hover:bg-white/[0.08] transition-colors">
                <link.icon size={18} weight="regular" className="text-[#A1A1AA] group-hover:text-[#EDEDED] transition-colors" />
              </div>
              <div>
                <div className="text-xs text-[#A1A1AA] font-mono mb-0.5">{link.label}</div>
                <div className="text-sm text-[#EDEDED] font-medium">{link.display}</div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-24 pt-8 border-t border-white/[0.06]">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-xs text-[#A1A1AA]/60 font-mono">
            Himanshu Goyal &mdash; {new Date().getFullYear()}
          </span>
          <span className="text-xs text-[#A1A1AA]/40 font-mono">
            Built with precision.
          </span>
        </div>
      </div>
    </section>
  );
};
